const crypto = require('crypto-js');
const JSEncrypt = require('jsencrypt');

const getPublicKey = () => {
  const publicKey = sessionStorage.getItem('publicKey');
  if (!publicKey) {
    throw new Error(`The public key is [null]`);
  }
  return publicKey;
};

/**
 * 加密
 *
 * @param data 加密前数据
 * @return {string} 加密后数据
 */
const encrypt = (data) => {
  let result = '';
  if (!data) {
    return result;
  }
  data = data instanceof Object ? JSON.stringify(data) : data.toString();
  const random = randomString(16);
  // 用AES加密明文数据
  const dataAfterAes = crypto.AES.encrypt(data, crypto.enc.Utf8.parse(random), {
    iv: crypto.enc.Utf8.parse('chinavisionaryiv'),
    mode: crypto.mode.CBC,
    padding: crypto.pad.ZeroPadding
  });
  return `${dataAfterAes}cvdata_separator${getRsaEncryptString(random)}`;
};


// RSA加密
const getRsaEncryptString = (data) => {
  let jencrypt = new JSEncrypt.JSEncrypt(); // 实例化加密对象
  jencrypt.setPublicKey(getPublicKey());
  return jencrypt.encrypt(data) // 加密明文
};


// 获取随机16位字符串
const randomString = (length) => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

export default encrypt;



